import { ServiceCalendarEntry } from "./ServiceCalendarEntry";
import type { ServiceOccurrence } from "@/types/service";
import { calendarDateKey } from "../calendar";

export function ServicesCalendar({ days, month, services, contextName }: {
  days: Date[]; month: Date; services: ServiceOccurrence[]; contextName: string;
}) {
  const byDate = new Map<string, ServiceOccurrence[]>();
  for (const service of services) {
    const key = calendarDateKey(new Date(service.starts_at));
    byDate.set(key, [...(byDate.get(key) ?? []), service]);
  }
  const today = calendarDateKey(new Date());
  return <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/80">
    <div className="min-w-[700px]">
      <div className="grid grid-cols-7 border-b border-slate-800" aria-hidden="true">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(day => <div key={day} className="p-3 text-center text-sm font-medium text-slate-400">{day}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {days.map(day => {
          const key = calendarDateKey(day);
          const events = (byDate.get(key) ?? []).sort((a, b) => a.starts_at.localeCompare(b.starts_at));
          return <section key={key} aria-label={day.toLocaleDateString(undefined, { dateStyle: "full" })}
            className={`min-h-36 border-b border-r border-slate-800 p-2 ${day.getMonth() === month.getMonth() ? "" : "bg-slate-950/50"}`}>
            <p className={`mb-2 flex h-7 w-7 items-center justify-center rounded-full text-sm ${key === today ? "bg-indigo-500 font-bold text-white" : "text-slate-400"}`}>
              <time dateTime={`${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`} aria-current={key === today ? "date" : undefined}>{day.getDate()}</time>
            </p>
            <div className="space-y-2">{events.map(service => <ServiceCalendarEntry key={service.id} service={service} contextName={contextName} />)}</div>
          </section>;
        })}
      </div>
    </div>
  </div>;
}
